import { configureStore } from '@reduxjs/toolkit';
import userData from '../redux/userData/index';
import coursesData from '../redux/coursesData';
import groupData from '../redux/groupData'
import chatData from '../redux/chatData'
import dripData from '../redux/dripData'

const store = configureStore({
  reducer: {
    userData: userData,
    coursesData: coursesData,
    groupData: groupData,
    chatData: chatData,
    dripData: dripData
  },
});

export default store;
